import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { setTokens } from "@/lib/rehearsalRoomAuth";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function RehearsalRoomLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const res = await fetch(`${BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || "Invalid email or password");
        return;
      }
      if (!data.user?.portal_role) {
        setError("This account doesn't have Rehearsal Room access yet.");
        return;
      }
      setTokens(data.access_token, data.refresh_token);
      navigate("/rehearsal-room", { replace: true });
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="min-h-screen flex items-center justify-center bg-paper px-6" data-testid="rehearsal-room-login">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm border border-ink/15 bg-paper px-8 py-10 shadow-[4px_8px_28px_rgba(27,27,24,0.08)]"
      >
        <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-3">InterAct Globally</p>
        <h1 className="font-serif text-2xl text-ink mb-6">Sign in to the Rehearsal Room</h1>

        <div className="space-y-4">
          <div>
            <Label htmlFor="rr-email">Email</Label>
            <Input
              id="rr-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="rehearsal-room-login-email"
            />
          </div>
          <div>
            <Label htmlFor="rr-password">Password</Label>
            <Input
              id="rr-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="rehearsal-room-login-password"
            />
          </div>
        </div>

        {error && (
          <p className="mt-4 text-sm text-red-700" data-testid="rehearsal-room-login-error">
            {error}
          </p>
        )}

        <Button
          type="submit"
          disabled={submitting}
          className="w-full mt-6"
          data-testid="rehearsal-room-login-submit"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </section>
  );
}
